module.exports = __webpack_public_path__ + "img/violet_119.a5620099.png";